import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

const valueObject = {
  ES: 'distance',
  UK: 'distance_miles',
  FR: 'distance',
  NL: 'distance',
  EU: 'distance',
};

const isDistanceMiles = ['UK'];

const enhance = compose(injectIntl);

const DistanceCell = React.memo(({ intl, route = {}, distance, distance_miles }) => {
  const units = intl.messages.units;
  const country = (route && route.country) || 'ES';
  const prop = valueObject[country];
  const value = isDistanceMiles.indexOf(country) >= 0 ? distance_miles : distance;
  return `${parseInt(value || distance, 10)} ${units[prop]}`;
});

DistanceCell.propTypes = {
  distance: PropTypes.number,
  distance_miles: PropTypes.number,
  route: PropTypes.object,
};

export default enhance(DistanceCell);
